export const overrideData = {
  //sweep angle
  sweepAngle: {
    //studio
    '68faff4fe62230d4b4454096': [
      { sceneId: '68fafb7ae62230d4b4453d49', defaultRotation: 6.2 },
      { sceneId: '68fafb6de62230d4b4453d30', defaultRotation: 1.6 },
      {
        sceneId: '68fa5dce3294b0149d46bb1f',
        defaultRotation: 6.2,
      },
      {
        sceneId: '68fa5dd33294b0149d46bb2a',
        defaultRotation: 6.2,
      },
    ],

    //3PN

    '68faff0de62230d4b445405f': [
      { sceneId: '68faffe9e62230d4b44540ff', defaultRotation: 3.2 },
      { sceneId: '68fafc43e62230d4b4453e08', defaultRotation: 3.2 },
      { sceneId: '68fafffae62230d4b4454114', defaultRotation: 3.5 },
      { sceneId: '68fafdaee62230d4b4453f99', defaultRotation: 3 },
      { sceneId: '68fafd8be62230d4b4453f60', defaultRotation: 6.2 },
      { sceneId: '68fafc59e62230d4b4453e29', defaultRotation: 4.7 },
      { sceneId: '68fafd9be62230d4b4453f75', defaultRotation: 1.5 },
      { sceneId: '68fafc29e62230d4b4453dee', defaultRotation: 6.2 },
      { sceneId: '69129061306dc464b887ed69', defaultRotation: 3.2 },
    ],

    //2PN
    '68fafeb5e62230d4b4454032': [
      { sceneId: '68fafb04e62230d4b4453c85', defaultRotation: 6.2 },
      { sceneId: '68fafa3fe62230d4b4453b4b', defaultRotation: 1.6 },
      { sceneId: '68fafa0ee62230d4b4453afb', defaultRotation: 6.2 },
      { sceneId: '68fafaade62230d4b4453b94', defaultRotation: 3.3 },
      { sceneId: '68fafac4e62230d4b4453bc0', defaultRotation: 4.6 },
      { sceneId: '68fafa1fe62230d4b4453b2c', defaultRotation: 4.6 },
      { sceneId: '68fadb1bbeb5aead0ada1cb8', defaultRotation: 6.2 },
    ],

    //1PN
    '68fafe28e62230d4b4453fdb': [
      { sceneId: '68fadb07beb5aead0ada1c60', defaultRotation: 3.3 },
      { sceneId: '68fadb0abeb5aead0ada1c6b', defaultRotation: 6.2 },
      { sceneId: '68fadb0cbeb5aead0ada1c76', defaultRotation: 3.3 },
      { sceneId: '68fadb0ebeb5aead0ada1c81', defaultRotation: 1.5 },
      { sceneId: '68fadb11beb5aead0ada1c8c', defaultRotation: 4.8 },
      { sceneId: '68fadb13beb5aead0ada1c97', defaultRotation: 6.2 },
    ],
  },

  //scene hotspots
  outDoorJumpSpots: [
    '68e768a4fa4f187e528e21c2',
    '68f9d3773294b0149d4685ba',

    //outdoor amenities
    '68fb02e7e62230d4b445441b',
    '68fb00d0e62230d4b44541ac',
    '68fb00c3e62230d4b4454193',
    '68fb00b9e62230d4b445417f',
    '68fb0303e62230d4b4454459',
    '68fb02f3e62230d4b445443c',
    '6903592c085ec50c650870ca',
    '695491fc6d44644c6c5909b6',
    '695398d76d44644c6c58a2bb',
  ],

  sceneFlycamOutdoorSpots: [
    '68d12cca208f82c724e17eb7',
    '68d12e81208f82c724e18004',
  ],

  //media hotspots
  internalAreaHotspots: [
    '68fb02e7e62230d4b445441b',
    '68fb00d0e62230d4b44541ac',
    '68fb00c3e62230d4b4454193',
    '68fb00b9e62230d4b445417f',
    '68fb0303e62230d4b4454459',
    '68fb02f3e62230d4b445443c',
    '6903592c085ec50c650870ca',
    '691d8f809d4e2e854cdb4192',
    '695491fc6d44644c6c5909b6',
    '695398d76d44644c6c58a2bb',
  ],

  amenitiesScenes: [
    '68fb02e7e62230d4b445441b',
    '68fb00d0e62230d4b44541ac',
    '68fb00c3e62230d4b4454193',
    '68fb00b9e62230d4b445417f',
    '68fb0303e62230d4b4454459',
    '68fb02f3e62230d4b445443c',
    '6903592c085ec50c650870ca',
    '691d8f809d4e2e854cdb4192',
    '695491fc6d44644c6c5909b6',
    '695398d76d44644c6c58a2bb',
  ],

  outDoorHotspots: [
    '68f9da7e3294b0149d468bbf',
    '68f9db2e3294b0149d468ce6',
    '68f9e8033294b0149d46977a',
    // '695491fc6d44644c6c5909b6',
    // '695398d76d44644c6c58a2bb',
  ],

  mediaHeights: [
    {
      mediaId: '68f9e8033294b0149d46977a',
      height: 1.5,
    },
  ],

  darkStyleHotspots: ['68f9da7e3294b0149d468bbf', '68f9db2e3294b0149d468ce6'],

  sceneTitle: [
    {
      sceneId: '68d1318e208f82c724e18089',
      title: 'Tầng 5',
    },
    {
      sceneId: '68d23c51208f82c724e1b8e3',
      title: 'Tầng 10',
    },
    {
      sceneId: '68d11fb3f1fff2aa8e505189',
      title: 'Tầng 15',
    },
    {
      sceneId: '68d11ff8f1fff2aa8e505326',
      title: 'Tầng 20',
    },
    {
      sceneId: '68d12016f1fff2aa8e50534e',
      title: 'Tầng 25',
    },
    {
      sceneId: '68d12769ddcbe92b6b39ad9e',
      title: 'Tầng 30',
    },
    {
      sceneId: '68d12cca208f82c724e17eb7',
      title: 'Toàn Cảnh 1',
    },
    {
      sceneId: '68d12e81208f82c724e18004',
      title: 'Toàn Cảnh 2',
    },
  ],
};

export const applyOverrideData = (json) => {
  if (!json || !Array.isArray(json.scenes)) return;

  const {
    outDoorJumpSpots,
    sceneFlycamOutdoorSpots,
    sceneTitle,
    outDoorHotspots,
    internalAreaHotspots,
    darkStyleHotspots,
    mediaHeights,
    amenitiesScenes,
    sweepAngle,
  } = overrideData;

  const outdoorIds = new Set(outDoorJumpSpots);
  const flycamIds = new Set(sceneFlycamOutdoorSpots);
  const outDoorHotspotIds = new Set(outDoorHotspots);
  const internalAreaHotspotIds = new Set(internalAreaHotspots);
  const darkStyleHotspotIds = new Set(darkStyleHotspots);
  const amenitiesSceneIds = new Set(amenitiesScenes);
  const mediaHeightMap = new Map(
    mediaHeights.map((item) => [item.mediaId, item.height])
  );

  const titleMap = new Map(
    sceneTitle.map((item) => [item.sceneId, item.title])
  );

  json.scenes.forEach((scene) => {
    if (outdoorIds.has(scene._id)) {
      scene.outdoorScene = true;
    }
    if (flycamIds.has(scene._id)) {
      scene.flycamOutdoorScene = true;
    }
    if (amenitiesSceneIds.has(scene._id)) {
      scene.amenitiesScene = true;
    }
    if (titleMap.has(scene._id)) {
      scene.amenitiesScene = true;
    }

    if (internalAreaHotspotIds.has(scene._id)) {
      scene.areaType = 'internalArea';
    }
  });

  json.media.forEach((media) => {
    if (outDoorHotspotIds.has(media._id)) {
      media.outDoorHotspot = true;
    }

    if (internalAreaHotspotIds.has(media._id)) {
      media.areaType = 'internalArea';
    }

    if (darkStyleHotspotIds.has(media._id)) {
      media.darkStyle = true;
    }

    if (mediaHeightMap.has(media._id)) {
      media.height = mediaHeightMap.get(media._id);
    }

    // Attach sweepAngle data by media id if configured (concise, no nested loops)
    if (sweepAngle && typeof sweepAngle === 'object') {
      const objects = media?.mapFloorPlan?.[0]?.objects;
      const list = sweepAngle[media._id];
      if (objects && Array.isArray(list) && list.length > 0) {
        const objectById = objects.reduce((acc, obj) => {
          acc[obj.id] = obj;
          return acc;
        }, {});
        list.forEach(({ sceneId, defaultRotation }) => {
          const target = objectById[sceneId];
          if (target) target.defaultRotation = defaultRotation;
        });
      }
    }
  });

  if (Array.isArray(json.menu)) {
    json.menu.forEach((menuGroup) => {
      if (Array.isArray(menuGroup.scenes)) {
        menuGroup.scenes.forEach((menuScene) => {
          if (titleMap.has(menuScene._id)) {
            menuScene.title = titleMap.get(menuScene._id);
          }
        });
      }
    });
  }
};

export default applyOverrideData;
